// extracted by mini-css-extract-plugin
module.exports = {"tablelist-row":"_1nsSO5m1HrRVI-TvlC8P4W","preLoaderShimmer":"_2DTp5pao2SNEFqDzhURB3B"};